<template>
  <div class="historym" ref="scrollbar">
    <div class="sticky">
      <div class="header">
        <img src="@/assets/mobile/back.png" alt="" @click="back()" />
        <p>创作历史</p>
      </div>
      <div class="list">
        <ul>
          <!-- <li @click="tree = true" v-if="items.length > activeIndex" style="height: 40px">
            {{ items[activeIndex].text }}
          </li> -->
          <!-- <li @click="tree = false" style="position: relative;z-index:100">
            <van-dropdown-menu >
              <van-dropdown-item v-historymmodel="value1" :options="option" @open="videostatus=false" @close="videostatus=true"/>
            </van-dropdown-menu>
          </li> -->
        </ul>
        <div v-show="tree" class="tree">
          <van-tree-select
            :items="items"
            :active-id.sync="activeId"
            :main-active-index.sync="activeIndex"
            @click-item="selectactiveId"
          />
        </div>
      </div>
    </div>
    <el-scrollbar ref="scrollbar">
      <div class="workbox">
        <ul v-show="activeIndex == 0">
          <li v-for="(item, index) in work" :key="index">
            <div
              class="listbox"
              @click.stop="(workIndex = index), (show3 = true)"
            >
              <div class="title">
                <p>{{ item.title }} | {{ item.problem }}</p>
                <p class="status" v-show="item.status==2">已生成</p>
                <p class="status" v-show="item.status==0">生成中</p>
                <p class="status" v-show="item.status==3">生成失败</p>
              </div>
              <div class="contenbox">
                <div class="content">{{ item.content }}</div>
                <div class="button" v-show="item.status==2">
                  <p>删除</p>
                  <p>复制</p>
                </div>
              </div>
            </div>
           <!-- <p class="createtime">{{ item.createtime }}</p> -->
          </li>
        </ul>
        <ul v-show="activeIndex == 1">
          <li v-for="(item, index) in video" :key="index" >
            <div class="listbox">
              <div class="title">
                <p>{{ item.title }} | {{ item.template_title }}</p>
                <p class="status" v-show="item.status==2">已生成</p>
                <p class="status" v-show="item.status==0">生成中</p>
                <p class="status" v-show="item.status==3">生成失败</p>
              </div>
              <div class="videobox" v-show="videostatus">
                <div @click="jumppage(item.id)" class="content">
                  <img :src="item.video_image" alt="" />
                  <img src="@/assets/mobile/play.png" alt="" class="play" />
                  <span>{{ item.createtime }}</span>
                </div>
                <div @click="downloadVideo(item.video_url)" class="button" v-show="item.status==2">
                  <p>下载</p>
                </div>
              </div>
            </div>
            <!-- <p class="createtime">{{ item.createtime }}</p> -->
          </li>
        </ul>
      </div>
    </el-scrollbar>
    <van-popup v-model="show3" position="bottom">
      <div class="task-details" v-if="work[workIndex]">
        <div class="task-header">
          <div class="task-top">
            <div class="task-top-left">{{ work[workIndex].title }}</div>
            <div class="task-top-right" @click="show3 = false">
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACQAAAAVCAYAAAAuJkyQAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEFSURBVHgBzdbNDYIwFAfw1zYC0QuhHDgyAiO4iY7hzREcwTiCExAn0KsnJzDexAMfFhINRCn9JPyT18BLyfuFpEkBJhkvirFLb6wqPAt3MGZ83ycuTTuzsRNsm8anHLqHMcIw2A3Ondl1vwR06WxEsLaOqjEZTtmwpN0mzVpk12q2YA5YtlAJIvO4KrIjmE4PpmQ/gnzf8udpFBQHA6/7gXQ220YNYOpn8vORLZQA5j/IBkoQ0w8yiZLA8EEmUJKYYZAOSgEjBlJBKWLEQTIoDYwcSASliZEHDaBQjjY6GDUQB8WWSAejDupDaWL0QByUKsZcvLC54CGHPsCjK5hE2AlrSjNvi9vRdNBJlAUAAAAASUVORK5CYII="
              />
            </div>
          </div>
          <div class="task-title">
            文章主题/关键词：{{ work[workIndex].title }}
          </div>
          <div class="task-prompt">
            <div class="task-prompt-left">
              <span class="task-prompt-icon"
                ><img
                  src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAQCAYAAAA1Qw7OAAAACXBIWXMAABYlAAAWJQFJUiTwAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACHSURBVHgBdY+BDUAwFER/OoERjGADNmAEm7CJEdiADTABG7DBdz/p0RSXXNrca6/9IpFUtYVVPsBswMlbg/wJFzIXBTXcY5sySCzQRxtBB6fw4cHIqgVOvE1T3E/lIeAbR/xF9tuvxPmwCPqHG0B5cHnFwYqg8OsOn3DJfsreGW0mgoaDMbwAf4eSbidLjYoAAAAASUVORK5CYII="
              /></span>
              内容由AI智能合成，使用时请遵守相关法律法规
            </div>
          </div>
          <div class="task-devide"></div>
        </div>
        <div class="task-content" v-html="work[workIndex].content"></div>
        <div class="footer-btn">
          <el-button type="primary" plain @click="wrting(work[workIndex].template_id)">再来一篇</el-button>
          <el-button
            type="primary"
            @click="copy($event, work[workIndex].content)"
            >复制文案</el-button
          >
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Clipboard from "clipboard";
import { articleGetUserCenterList, videoGetUserCenterList } from "@/api/user";
export default {
  data() {
    return {
      videostatus: true,
      show3: false,
      tree: false,
      activeId: 0,
      activeIndex: 0,
      workIndex: 0,
      value1: "0",
      option: [
        {
          text: "全部状态",
          value: "0",
        },
        {
          text: "已生成",
          value: "1",
        },
        {
          text: "创作中",
          value: "2",
        },
        {
          text: "生成失败",
          value: "3",
        },
      ],
      items: [
        {
          id: 0,
          text: "文字创作1",
          children: [],
        },
        {
          id: 1,
          text: "视频创作",
          children: [],
        },
      ],
      work: [{}],
      video: [],
      articleform: {
        keyword: "",
        tid: "",
        page: 1,
      },
      videoform: {
        tid: "",
        page: 1,
      },
      articlePage: 1,
      videoPage: 1,
    };
  },
  mounted() {
    if(this.$route.params.type){
      this.activeIndex = this.$route.params.type;
    }
	this.activeIndex = 1;
    this.scrollbar(); //el-scrollbar触底事件
    this.articleGetUserCenterList(false);
    this.videoGetUserCenterList(false);
  },
  methods: {
	downloadVideo(url) {
		  window.open(url)
	},
    wrting(id){
      this.$router.push({ path: "/copywriting/"+id });
    },
    selectactiveId(e) {
      this.activeId = Number(e.id);
      this.articleform.tid = this.activeId;
      this.videoform.tid = this.activeId;
      this.tree = false;
      if (this.activeIndex == 0) {
        this.articleGetUserCenterList(false);
      } else {
        this.videoGetUserCenterList(false);
      }
    },
    copy(event, content) {
      const clipboard = new Clipboard(event.target, {
        text: () => content,
      });
      clipboard.on("success", () => {
        clipboard.destroy();
        this.$message({
          message: "复制成功",
          type: "success",
          duration: 3 * 1000,
        });
      });
      clipboard.on("error", () => {
        clipboard.destroy();
        this.$message({
          message: "复制失败",
          type: "error",
          duration: 3 * 1000,
        });
      });
      clipboard.onClick(event);
    },
    back() {
      this.$router.back();
    },
    jumppage(id) {
      this.$router.push({ path: "/videoplaym?id=" + id });
    },
    articleGetUserCenterList(status) {
      articleGetUserCenterList(this.articleform).then((res) => {
        if (status) {
          this.work.concat(res.data.list.data);
        } else {
          this.work = res.data.list.data;
        }
        this.items[0].children = res.data.template.map((item) => {
          return { text: item.title, id: item.id };
        });
        this.items[0].children.unshift({
          id: 0,
          text: "全部",
        });
        this.articlePage = res.data.last_page;
      });
    },
    videoGetUserCenterList(status) {
      videoGetUserCenterList(this.videoform).then((res) => {
        if (status) {
          this.video.concat(res.data.list.data);
        } else {
          this.video = res.data.list.data;
        }
        this.items[1].children = res.data.template.map((item) => {
          return { text: item.title, id: item.id };
        });
        this.items[1].children.unshift({
          id: 0,
          text: "全部",
        });
        this.videoPage = res.data.last_page;
      });
    },
    scrollbar() {
      
      this.$refs.scrollbar.handleScroll = () => {
        console.log(123)
        var wrap = this.$refs.scrollbar.wrap;
        this.$refs.scrollbar.moveY = (wrap.scrollTop * 100) / wrap.clientHeight;
        this.$refs.scrollbar.moveX = (wrap.scrollLeft * 100) / wrap.clientWidth;
        let poor = wrap.scrollHeight - wrap.clientHeight;
        if (
          poor == parseInt(wrap.scrollTop) ||
          poor == Math.ceil(wrap.scrollTop) ||
          poor == Math.floor(wrap.scrollTop)
        ) {
          switch (this.activeIndex) {
            case 0:
              if (this.articleform.page < this.articlePage) {
                this.articleform.page++;
                this.articleGetUserCenterList(true);
              }
              break;
            case 1:
              if (this.videoform.page < this.videoPage) {
                this.videoform.page++;
                this.videoGetUserCenterList(true);
              }
              break;
          }
        }
      };
    },
  },
};
</script>

<style lang="less">
.historym {
  .el-scrollbar{
    height: calc(100vh - 100px);
  }
  .sticky {
    // position: sticky;
    // top: 0;
    // left: 0;
    width: 100%;
    background-color: #fff;
  }
  .header {
    display: flex;
    align-items: center;
    height: 60px;
    img {
      height: 18px;
      padding: 0 20px;
    }
    p {
      flex: 1 0 10%;
      text-align: center;
      font-size: 18px;
      font-weight: 700;
      padding-right: 30px;
    }
  }
  .list {
    ul {
      display: flex;
      padding: 0 10px;
      gap: 10px;
      li {
        display: flex;
        align-items: center;
        font-size: 15px;
        line-height: 22px;
      }
      .van-dropdown-menu__bar {
        box-shadow: none;
      }
    }
    .tree {
      position: relative;
      z-index: 20;
      width: 100%;
      height: calc(100vh - 108px);
      background-color: rgba(0, 0, 0, 0.533);
    }
  }
  .workbox {
    padding: 16px 20px 0;
    background: #fbfcfd;
    li {
      margin-bottom: 20px;
    }
    .listbox {
      max-height: 100%;
      padding: 16px 12px;
      background-color: #fff;
      border-radius: 8px;
      box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
      font-size: 14px;
      color: #333;
      cursor: pointer;
      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 12px;
        .status {
          padding: 4px 8px;
          background: #e7f9f4;
          color: #38b865;
          border-radius: 4px;
          font-size: 12px;
          text-align: center;
        }
      }
      .contenbox {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        height: 120px;
        padding: 12px;
        background: #f8f9f9;
        border-radius: 8px;
        font-size: 14px;
        color: #333;
        margin-bottom: 12px;
        cursor: pointer;
        .content {
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
          overflow: hidden;
          color: #000;
        }
        .button {
          display: flex;
          justify-content: flex-end;
          gap: 12px;
          margin-top: 12px;
          p {
            padding: 5px 22px;
            text-align: center;
            background: #ffffff;
            border-radius: 32px;
            cursor: pointer;
          }
        }
      }
      .videobox {
        .content {
          border-radius: 8px;
          overflow: hidden;
          position: relative;
          z-index: 1;
          .play {
            width: 40px;
            position: absolute;
            z-index: 1;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
          }
          img {
            width: 100%;
          }
          span {
            position: absolute;
            right: 4px;
            bottom: 4px;
            padding: 2px 4px;
            font-size: 12px;
            color: #fff;
            background: rgba(0, 0, 0, 0.6);
            border-radius: 4px;
          }
        }
        .button {
          display: flex;
          justify-content: flex-end;
          gap: 12px;
          margin-top: 12px;
          p {
            padding: 5px 22px;
            text-align: center;
            background: #f4f4f4;
            border-radius: 32px;
            cursor: pointer;
          }
        }
      }
    }
    .createtime {
      font-size: 10px;
      color: #999;
      margin-top: 8px;
    }
  }
  .task-details {
    .task-header {
      padding: 20px 20px 0;
      background: linear-gradient(
          180deg,
          #ecf3ff 0%,
          rgba(255, 255, 255, 0) 98.02%
        ),
        #ffffff;
      .task-top {
        display: flex;
        justify-content: space-between;
        align-items: center;
        img {
          width: 16px;
        }
      }
      .task-title {
        font-weight: 700;
        margin: 8px 0;
        font-size: 16px;
        max-height: 3em;
        overflow: auto;
      }
      .task-prompt {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 0 10px 0 8px;
        height: 28px;
        color: #2d8af5;
        background: rgba(231, 239, 255, 0.3);
        border-radius: 4px;
        font-size: 12px;
        .task-prompt-left {
          display: flex;
          align-items: center;
        }
        .task-prompt-icon {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 14px;
          height: 14px;
          border-radius: 50%;
          background: #2d8af5;
          margin-right: 4px;
          img {
            width: 4px;
          }
        }
      }
      .task-devide {
        margin: 12px 0;
        background-color: #f4f4f4;
        width: 100%;
        height: 1px;
      }
    }
    .task-content {
      padding: 0 20px 12px;
      flex: 1;
      overflow: auto;
      font-size: 10px;
      line-height: 1.5;
    }
    .footer-btn {
      width: 100%;
      display: flex;
      padding: 20px 0;
      justify-content: center;
      border-top: 1px solid #f4f4f4;
      .el-button {
        width: 150px;
      }
    }
  }
}
</style>